module.exports = __webpack_public_path__ + "img/allstudents.61bb31f8.svg";